import { render, staticRenderFns } from "./brand-portal-access.vue?vue&type=template&id=94028bcc&scoped=true"
import script from "./brand-portal-access.vue?vue&type=script&lang=ts"
export * from "./brand-portal-access.vue?vue&type=script&lang=ts"
import style0 from "./brand-portal-access.vue?vue&type=style&index=0&id=94028bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94028bcc",
  null
  
)

export default component.exports